"use client";

import { Button } from "../ui/button";

import { useOAuthInit } from "../lib/hooks/use-auth";
import { FaGoogle } from "react-icons/fa";

type GoogleAuthButtonProps = {
  platform: string;
};

export function GoogleAuthButton({ platform }: GoogleAuthButtonProps) {
  const { mutate: initOAuth, isPending } = useOAuthInit();

  const handleGoogleLogin = () => {
    initOAuth({
      platform,
      callbackUrl: `${window.location.origin}/auth/callback`,
    });
  };

  return (
    <Button
      className="font-semibold flex-1 py-2 justify-start bg-[#4C8BF5] rounded text-white hover:bg-[#296AD6] hover:shadow-[0px_10px_26px_#4C8BF566]"
      onClick={handleGoogleLogin}
      disabled={isPending}
      loading={isPending}
      type="button"
    >
      <FaGoogle className="mr-2" />
      <span className="text-sm font-medium">Continue with Google</span>
    </Button>
  );
}
